import { Box, Button, Typography } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Outlet } from "react-router";
import NotificationSnackBar from "../../components/NotificationSnackBar";
import { resetNotification } from "../../redux/slices/notificationsSlice";
import { getMe } from "../../redux/slices/userSlice";
import TopBarAdmin from "./components/TopBarAdmin";
import { useMediaQuery } from "react-responsive";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { Stack } from "@mui/system";
import { logOut } from "../../redux/slices/authenticationSlice";
import { useAuth } from "../../hooks/useAuth";

const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    height: "100vh",
  },
};
const AdminHome = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { logout } = useAuth();
  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });

  const notificationsState = useSelector((state) => state.notifications);
  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);
  const handleOnCloseNotificationSnackBar = () => {
    dispatch(resetNotification());
  };
  const onLogout = () => {
    dispatch(logOut()).then(() => {
      logout();
    });
  };
  // useEffect(() => {
  //   dispatch(getUserRole());
  // }, [dispatch]);
  return (
    <div style={styles.root}>
      {isMobile ? (
        <Stack
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="100%"
          textAlign="center"
        >
          <WarningAmberIcon sx={{ fontSize: 80 }} color="error" />
          <Typography color="error" variant="h3">
            {t("onlyOnBigScreenViewing")}
          </Typography>
          <Button onClick={onLogout}>{t("login.logOut")}</Button>
        </Stack>
      ) : (
        <>
          <TopBarAdmin />
          <Box paddingTop={6} paddingBottom={6}>
            <Outlet />
          </Box>
          <NotificationSnackBar
            open={notificationsState.show}
            onClose={handleOnCloseNotificationSnackBar}
            message={notificationsState.message}
            duration={notificationsState.duration}
            severity={notificationsState.severity}
          />
        </>
      )}
    </div>
  );
};
export default AdminHome;
